/**
 * Markdown ⇄ BlockNote conversions without a mounted editor. Loaded lazily so
 * the main bundle never pulls BlockNote in; only accepting an AI page edit or
 * creating a page from the assistant needs it.
 */
export const markdownToBlocks = async (markdown: string): Promise<unknown[]> => {
  const { BlockNoteEditor } = await import('@blocknote/core')
  // the page schema, so a ```mermaid fence becomes a diagram block
  const { schema } = await import('./editor')
  const editor = BlockNoteEditor.create({ schema })
  return (await editor.tryParseMarkdownToBlocks(markdown)) as unknown[]
}
